import store from '@/store';

import CookieUtil from '@/services/Util/cookieUtil';

interface Logout {
  isAnonymousPage?: boolean;
}

function removeTokenFromUrl(url: string): string {
  const parsedUrl = new URL(url);

  if (parsedUrl.searchParams.has('token')) {
    parsedUrl.searchParams.delete('token');
    return parsedUrl.origin + parsedUrl.pathname + (parsedUrl.search ? `?${parsedUrl.searchParams.toString()}` : '');
  }

  return url;
}

export const logout = ({ isAnonymousPage }: Logout) => {
  store.commit('setToken', '');
  const cameFromStore = window.location.pathname.includes('loja');

  const DEFAULT_URL = `https://acesso.explicae.com.br/${cameFromStore ? 'cadastro' : 'login'}`;
  const institutionURL = store.getters.profile.institution?.url;

  let url = window.location.href;
  url = removeTokenFromUrl(url);

  localStorage.removeItem('ex-simulated');

  CookieUtil.removeAccess();
  if (isAnonymousPage) return;

  if (!institutionURL) {
    window.location.href = `${DEFAULT_URL}/?url=${encodeURIComponent(
      // eslint-disable-next-line comma-dangle
      url
    )}`;
  } else {
    window.location.href = `${institutionURL}/?url=${encodeURIComponent(
      // eslint-disable-next-line comma-dangle
      url
    )}`;
  }
};
